import { c as _c } from "react/compiler-runtime";
import { IcoTrash16 } from '@onefootprint/icons';
type RemoveButtonProps = {
  label: string;
  onClick: () => void;
};
export const TypeChip = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="inline-flex shrink-0 items-center gap-0.5 rounded border border-tertiary bg-secondary px-1.5 py-0.5 text-snippet-3 text-tertiary">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const RemoveButton = t0 => {
  const $ = _c(4);
  const {
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoTrash16 color="tertiary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label || $[2] !== onClick) {
    t2 = <button type="button" aria-label={label} className="flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-(--icon-button-border-radius-tiny) hover:bg-hover-control" onClick={onClick}>{t1}</button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const SectionHeading = t0 => {
  const $ = _c(7);
  const {
    title,
    hint
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-heading-5 text-primary">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hint) {
    t2 = <p className="text-body-2 text-tertiary">{hint}</p>;
    $[2] = hint;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div data-card-header={true} className="flex flex-col gap-1 px-4 py-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};